module.exports = __webpack_public_path__ + "static/media/vf_wskirt_core.a7458e5a.svg";